import StandingsTestingBase from "./StandingsTestingBase";

export default function StandingsTestingAm() {
    return (
        <StandingsTestingBase
            scopeType="DRIVER"
            classKey="AM"
            heading="Meisterschaftswertung"
            pillLabel="AM"
        />
    );
}
